import { render } from "./color-picker.vue?vue&type=template&id=3aecd678"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"

import "./color-picker.vue?vue&type=style&index=0&id=3aecd678&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__